var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("customer-application-table", {
        on: { "show-application": _vm.showApplication }
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "30vw", eager: "" },
          model: {
            value: _vm.customerApplicationShowDialog,
            callback: function($$v) {
              _vm.customerApplicationShowDialog = $$v
            },
            expression: "customerApplicationShowDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("customer-application-show", {
                ref: "customer-application-show"
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }